import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { moduleActions } from '../../../redux/modules';
import { getSelectedBank } from '../../../redux/modules/bankSelection/bankSelection.selectors';

import {
  getIRALimit,
  getIsFullyContributedIRA,
  getWindowCutoffDate,
} from '../../../redux/modules/funds/IRA/IRA.selectors';
import { getIRALimitSearchDataByPoid } from '../../../redux/modules/funds/IRALimitSearch/IRALimitSearch.selectors';
import { isAPP, isRAS } from '../../../utils/advice/advice-utility';
import { getUserFunds } from '../../../redux/modules/funds/UserFunds/userFunds.selectors';
import { getProgressCurrentStep } from '../../../redux/modules/progress/selectors';
import { getQuickBuy } from '../../../redux/modules/quickBuy/quickBuy.selectors';
import {
  getAvailableEditFund,
  getAvailableFundList,
  getAvailableFundListRecurring,
  getAvailableFundListIRAAutoMax,
  getCurrentYearInclusiveRemainingContributions,
  getHasAtleastOneFullyContributedIRA,
  getHasAtleastOneFullyContributedIRARecurring,
  getHiddenAccountNumber,
  getIRADataLookUp,
  getIsCorporateAccountType,
  getNonRetirementMaxLimit,
  getPriorYearInclusiveRemainingContributions,
  getPurchasingFunds,
  getRecurringPurchasingFunds,
  getShoppingCartTotal,
  getUserFundList,
  getSelectedIRAAutoMaxFunds,
} from '../../../redux/modules/shoppingCart/shoppingCart.selectors';
import {
  getPersonalInformationData,
  getHouseholdBalanceTierStatus,
} from '../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import { getAllFundsList } from '../../../redux/modules/funds/AllFunds/allFunds.selectors';
import { scrollElementIntoFullView } from '../../../utils/dom-utils';
import { hasOnlyRetirementFunds } from '../../../utils/funds/funds-utility';
import {
  isAppBuy,
  isBuy,
  isCollegeContribute,
  isRecurringBuyEdit,
  isIRAAutoMax,
} from '../../../utils/transactions-util';
import CollegeContributeFundEditor from '../../CollegeContribute/CollegeContributeFundEditor/CollegeContributeFundEditor';
import ActivePlusRecurringBuyFundEditor from '../../RecurringBuy/RecurringBuyFundEditor/ActivePlusRecurringBuyFundEditor';
import RecurringBuyFundEditor from '../../RecurringBuy/RecurringBuyFundEditor/RecurringBuyFundEditor';
import IRAAutoMaxEditor from '../../IRAAutoMax/IRAAutoMaxEditor/IRAAutoMaxEditor';
import If from '../../Shared/If/If';
import StepExpanded from '../../Shared/StepExpanded/StepExpanded';
import BuyFundEditor from './BuyFundEditor/BuyFundEditor';
import CollapsedFundList from './CollapsedFundList';
import ExpandedFundList from './ExpandedFundList/ExpandedFundList';
import './FundList.scss';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import IRAAutoMaxCollapsed from './CollapsedFundList/IRAAutoMaxCollapsed';
export class FundList extends Component {
  constructor(props) {
    super(props);
    this.editButtonClickHandler = this.editButtonClickHandler.bind(this);
  }

  editButtonClickHandler() {
    const {
      actions: { setProgress },
    } = this.props;
    setProgress(2);
    scrollElementIntoFullView('funding-source-step', 15);
  }

  /**
   * Get all iclass versions of available funds to the user
   * @param {Funds[]} availableFunds
   * @param {Funds[]} allFunds
   */
  getAvailableIClassFundsLookup(availableFunds, allFunds) {
    return availableFunds.reduce((acc, fund) => {
      const currentFundTicker = fund.ticker;
      const iClassVer = allFunds.find(
        (fund) => fund.ticker === currentFundTicker
      );
      const iClassInfo = allFunds.find(
        (fund) => fund.ticker === iClassVer?.correspondingFund?.ticker
      );
      return !!iClassVer?.correspondingFund
        ? {
            ...acc,
            [fund.agreementID]: {
              ...iClassInfo,
            },
          }
        : acc;
    }, {});
  }

  render() {
    const {
      isSalesforceRep,
      customerWebViewEnabled,
      actions,
      allFunds,
      availableFunds,
      clickable,
      currentStep,
      currentYearInclusiveRemainingContributions,
      displayTradeDate,
      IRADataLookUp,
      IRALimit,
      hasAtleastOneFullyContributedIRA,
      hiddenAccountsNumber,
      isCorporateAccountType,
      isFullyContributedIRA,
      isRecurring,
      nonRetirementMaxLimit,
      passthroughProps,
      personalData,
      priorYearInclusiveRemainingContributions,
      purchasingFunds,
      quickBuy,
      selectedBank,
      shoppingCartTotal,
      userFunds,
      userFundsList,
      windowCutoffDate,
      IRALimitSearchByPoid,
      householdBalanceTierStatus,
      selectedIRAAutoMaxFunds,
    } = this.props;
    const active = currentStep === 2;
    const showAddNewFundOrAccount = isBuy()
      ? selectedBank &&
        (!selectedBank.sameDayBank ||
          (selectedBank.sameDayBank && selectedBank.externallyVerifiedBank))
      : isBuy();
    const getFundEditor = (fund) => {
      return isIRAAutoMax()
        ? false
        : isBuy() || isAppBuy()
        ? BuyFundEditor
        : isAPP(fund.productType) || isRAS(fund.productType) // Check if an extra condition is needed to ascertain flow
        ? ActivePlusRecurringBuyFundEditor
        : isCollegeContribute()
        ? CollegeContributeFundEditor
        : RecurringBuyFundEditor;
    };

    return (
      <div
        className={classNames('animated', 'fadeInUp', 'fund-list-fundsBox', {
          'fund-list-active': active,
        })}
      >
        <If test={!isIRAAutoMax() && !active && purchasingFunds.length}>
          <CollapsedFundList
            clickable={clickable}
            isRecurring={isRecurring}
            shoppingCartLength={purchasingFunds.length}
            shoppingCartTotal={shoppingCartTotal}
            onEditClick={this.editButtonClickHandler}
            isIRAAutoMax={isIRAAutoMax()}
          />
        </If>
        {isIRAAutoMax() && currentStep !== 2 && (
          <React.Fragment>
            <IRAAutoMaxCollapsed
              clickable={clickable}
              onEditClick={this.editButtonClickHandler}
              selectedFundsCount={selectedIRAAutoMaxFunds.length}
            />
          </React.Fragment>
        )}
        <If test={active}>
          <StepExpanded>
            <ExpandedFundList
              {...{
                isSalesforceRep,
                customerWebViewEnabled,
                actions,
                availableFunds,
                currentStep,
                currentYearInclusiveRemainingContributions,
                displayTradeDate,
                hasAtleastOneFullyContributedIRA,
                hiddenAccountsNumber,
                IRADataLookUp,
                IRALimit,
                isCorporateAccountType,
                isFullyContributedIRA,
                nonRetirementMaxLimit,
                passthroughProps,
                personalData,
                priorYearInclusiveRemainingContributions,
                quickBuy,
                showAddNewFundOrAccount,
                userFunds,
                windowCutoffDate,
                householdBalanceTierStatus,
              }}
              canAddNewFund={
                !hasOnlyRetirementFunds(userFunds) ||
                !hasAtleastOneFullyContributedIRA
              }
              fundEditor={getFundEditor}
              iClassFundLookUp={this.getAvailableIClassFundsLookup(
                availableFunds,
                allFunds
              )}
              isManySelect={false}
              IRADataLookUp={IRADataLookUp}
              IRALimit={IRALimit}
              IRALimitSearchByPoid={IRALimitSearchByPoid}
              hasAtleastOneFullyContributedIRA={
                hasAtleastOneFullyContributedIRA
              }
              hiddenAccountsNumber={hiddenAccountsNumber}
              isCorporateAccountType={isCorporateAccountType}
              isFullyContributedIRA={isFullyContributedIRA}
              nonRetirementMaxLimit={nonRetirementMaxLimit}
              numberOfFunds={userFundsList.length}
              quickBuyFunds={userFundsList}
            />
            {isIRAAutoMax() && <IRAAutoMaxEditor {...{ actions }} />}
          </StepExpanded>
        </If>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allFunds: getAllFundsList(state),
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    availableFunds: isRecurringBuyEdit()
      ? getAvailableEditFund(state)
      : isBuy() || isAppBuy()
      ? getAvailableFundList(state)
      : isIRAAutoMax()
      ? getAvailableFundListIRAAutoMax(state)
      : getAvailableFundListRecurring(state),
    currentStep: getProgressCurrentStep(state),
    currentYearInclusiveRemainingContributions:
      getCurrentYearInclusiveRemainingContributions(state),
    hasAtleastOneFullyContributedIRA:
      isBuy() || isAppBuy()
        ? getHasAtleastOneFullyContributedIRA(state)
        : getHasAtleastOneFullyContributedIRARecurring(state),
    hiddenAccountsNumber: getHiddenAccountNumber(state),
    IRADataLookUp: getIRADataLookUp(state),
    IRALimit: getIRALimit(state),
    IRALimitSearchByPoid: getIRALimitSearchDataByPoid(state),
    isCorporateAccountType: getIsCorporateAccountType(state),
    isFullyContributedIRA: getIsFullyContributedIRA(state),
    nonRetirementMaxLimit: getNonRetirementMaxLimit(state),
    personalData: getPersonalInformationData(state), // Todo: Swap name personalData for personalInformationData (Leave in place now for backwards compatibility)
    priorYearInclusiveRemainingContributions:
      getPriorYearInclusiveRemainingContributions(state),
    purchasingFunds: isRecurringBuyEdit()
      ? getAvailableEditFund(state)
      : isBuy() || isAppBuy()
      ? getPurchasingFunds(state)
      : getRecurringPurchasingFunds(state),
    quickBuy: getQuickBuy(state),
    selectedBank: getSelectedBank(state),
    shoppingCartTotal: getShoppingCartTotal(state),
    userFunds: getUserFunds(state),
    userFundsList: getUserFundList(state),
    windowCutoffDate: getWindowCutoffDate(state),
    householdBalanceTierStatus: getHouseholdBalanceTierStatus(state),
    selectedIRAAutoMaxFunds: isIRAAutoMax()
      ? getSelectedIRAAutoMaxFunds(state)
      : 0,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(FundList);
